import request from "@/utils/request";
import { getUploadBaseApi, buildUploadHeaders } from "@/utils/uploadApiHelper";

export async function upload(formData) {
  const baseURL = getUploadBaseApi();
  return request({
    url: "/file/sysFileInfo/upload",
    method: "POST",
    baseURL,
    headers: await buildUploadHeaders(baseURL),
    data: formData,
  });
}
